import _ from "lodash"
import { pushDataLayer } from "./pushDataLayer"
import {
  GTM_SELECT_SEARCH_MODE,
  GTM_SELECT_PARKING_RESULT,
  GTM_SET_PARKING,
  GTM_CONFIRM_PARKING,
  GTM_REQUEST_CLEAR_PARKING,
  GTM_CLEAR_PARKING,
  GTM_VIEW_SAVED_PARKING,
} from "constant"

const getFeatureParams = (feature: any) => ({
  feature_id: _.get(feature, "id"),
  feature_name: _.get(feature, "properties.name.en"),
})

export const gtmPushDataLayerSelectSearchMode = (searchMode: string) => {
  pushDataLayer({
    event: GTM_SELECT_SEARCH_MODE,
    search_mode: searchMode,
  })
}

export const gtmPushDataLayerSelectParkingResult = (
  feature: any,
  keyword: string
) => {
  pushDataLayer({
    event: GTM_SELECT_PARKING_RESULT,
    ...getFeatureParams(feature),
    keyword: keyword || "",
  })
}

export const gtmPushDataLayerSetParking = (feature: any) => {
  pushDataLayer({
    event: GTM_SET_PARKING,
    ...getFeatureParams(feature),
  })
}

export const gtmPushDataLayerConfirmParking = (
  feature: any,
  previousParkingName: string
) => {
  pushDataLayer({
    event: GTM_CONFIRM_PARKING,
    ...getFeatureParams(feature),
    previous_parking_name: previousParkingName,
  })
}

export const gtmPushDataLayerRequestClearParking = (feature: any) => {
  pushDataLayer({
    event: GTM_REQUEST_CLEAR_PARKING,
    ...getFeatureParams(feature),
  })
}

export const gtmPushDataLayerClearParking = (feature: any) => {
  pushDataLayer({
    event: GTM_CLEAR_PARKING,
    ...getFeatureParams(feature),
  })
}

export const gtmPushDataLayerViewSavedParking = (feature: any) => {
  pushDataLayer({
    event: GTM_VIEW_SAVED_PARKING,
    ...getFeatureParams(feature),
  })
}
